import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getFilteredParameterValuesNotEmpty } from 'store/dataset';
import { getDotsForProbabilityPlot } from 'calculators/graphicalStatistics/probabilityPlot';

import CheckBox from 'components/CheckBox';
import ScatterPlot from 'components/ScatterPlot';

const ProbabilityPlot = ({
  nameParameter,
  firstParsedParameterValues
}) => {
  const [showRegressionLine, setShowRegressionLine] = useState(false);
  const dots = () =>
    getDotsForProbabilityPlot(firstParsedParameterValues);

  const handleRegressionLineCheckboxChange = ({ target }) =>
    setShowRegressionLine(target.checked);

  return (
    <>
      <div className="text-left pl-50">
        <CheckBox
          checked={showRegressionLine}
          onChange={handleRegressionLineCheckboxChange}
        >
          Overlay Line
        </CheckBox>
      </div>
      <ScatterPlot
        showRegressionLine={showRegressionLine}
        dots={dots()}
        xAxisLabel="z Percentile"
        yAxisLabel={nameParameter}
      />
    </>
  );
};

ProbabilityPlot.propTypes = {
  nameParameter: PropTypes.string.isRequired,
  firstParsedParameterValues: PropTypes.array.isRequired
};

const mapStateToProps = (state, props) => ({
  nameParameter: props.parameter,
  firstParsedParameterValues: getFilteredParameterValuesNotEmpty(state, props.parameter)
});

export default connect(mapStateToProps)(ProbabilityPlot);
